import { render } from "./Marcas.vue?vue&type=template&id=90abe5b6&scoped=true&ts=true"
import script from "./Marcas.vue?vue&type=script&lang=ts"
export * from "./Marcas.vue?vue&type=script&lang=ts"

import "./Marcas.vue?vue&type=style&index=0&id=90abe5b6&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90abe5b6"]])

export default __exports__